import type { ComparisonBlockView, ComparisonView } from "../../../../clients/Purchaser/Compare.ts";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "../../compare-generic.css";
import GenericBlock from "./GenericBlock.tsx";
import TableBlock from "./TableBlock.tsx";
import ProgressBar from "../ProgressBar.tsx";

function renderBlock(block: ComparisonBlockView) {
    switch (block.type) {
        case "Vendors":
        case "Cost Overview":
            return <TableBlock block={block} />;
        default:
            return <GenericBlock block={block} />;
    }
}

/**
 * Given an array of blocks, render the correct component to show the content.
 */
export default function ComparisonBlocks({ comparison, excludeBlocks }: { comparison: ComparisonView; excludeBlocks?: string[] }) {
    const blocksToRender = comparison.blocks.filter(block => !excludeBlocks?.includes(block.type));
    return (
        <div className="relative px-5 pt-4 lg:px-10">
            {comparison.title && <h1 className="mb-4 text-2xl font-semibold">{comparison.title}</h1>}
            <Markdown remarkPlugins={[remarkGfm]}>{comparison.summary}</Markdown>
            <div className="mt-8 flex flex-col gap-y-8">
                {blocksToRender.map(block => (
                    <div className="max-w-full overflow-x-auto" key={block.id}>
                        {renderBlock(block)}
                    </div>
                ))}
            </div>
            <ProgressBar comparison={comparison} />
        </div>
    );
}
